import { Component, inject, OnInit, signal } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/shared/shared.module";
import { CommonModule } from "@angular/common";
import { forkJoin, Observable } from "rxjs";
import { CourseService } from "src/app/services/api/courses.service";
import { RouterModule } from "@angular/router";
import { CourseRecommendItemComponent } from "./course-recommend-item/course-recommend-item.component";

@Component({
  selector: "app-courses",
  imports: [
    SharedModule,
    TranslateModule,
    CommonModule,
    RouterModule,
    CourseRecommendItemComponent,
  ],
  templateUrl: "./courses.component.html",
  styleUrl: "./courses.component.scss",
})
export class CoursesComponent implements OnInit {
  #courseService = inject(CourseService);
  courses: any;

  isLoading = signal(true);

  ngOnInit(): void {
    this.getMasterData();
  }

  _setLoading(value: boolean, time: number = 500) {
    setTimeout(() => {
      this.isLoading.update((_) => value);
    }, time);
  }

  getMasterData() {
    const params = {
      is_recommend: true,
      is_disabled: false,
      limit: 4,
    };

    forkJoin([
      this.#courseService.getCourses(params) as Observable<any>,
    ]).subscribe({
      next: ([courses]) => {
        this.courses = courses;
        // this.courses.push(...courses,...courses,...courses);

      },
      error: (error) => { },
      complete: () => {
        this._setLoading(false);
      },
    });
  }
}
